import React, { useState, useEffect } from 'react';
import { useChat } from '../context/ChatContext';

const ConnectionStatus = () => {
  const { socket } = useChat();
  const [isDisconnected, setIsDisconnected] = useState(socket ? !socket.connected : false);

  useEffect(() => {
    if (!socket) return;

    function onConnect() { setIsDisconnected(false); }
    function onDisconnect() { setIsDisconnected(true); }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
    };
  }, [socket]);

  if (!isDisconnected) return null;

  return (
    <div className="connection-toast">
      <span className="pulse-dot warning"></span>
      جاري إعادة الاتصال بالخادم...
    </div>
  );
};

export default ConnectionStatus;
